// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".factors-tab[data-v-d9aac0f2]{min-height:100%;background:var(--v-gray-extra-light);overflow:auto;padding-top:var(--spacer-half)}", ""]);
// Exports
module.exports = exports;
